import React, { Component } from 'react';
import { Switch, Spin, Tooltip, Modal, Button, notification } from 'antd';
import moment from 'moment';
import { CloseOutlined, CheckOutlined } from '@ant-design/icons';
import { formDataSchema } from '../../../../schema/privilege';
import Inputlayer from '../../../../components/FormComponent/Input';
import { mapObjIndexed } from 'ramda';
import networkList from '../../../../constants/networkList';
import postService from '../../../../services/httpService';
import Select2 from '../../../../components/FormComponent/select2';
import Storage from '../../../../services/local-store';
import userTrackService from './../../../../services/usertrack-service';
const $ = require('jquery');
const { confirm } = Modal;
const {homepage} = networkList;
class Privilege_Create extends Component {
    constructor(props) {
        super(props)
        this.state = {
            visible: false,
            btnloading: false,
            loadding: false,
            date: new Date(),
            formData: [],
            'tbody': [],
            privilege_name: '',
            privilege_id: '',
            message: 'Please, try again',
            "showAdd": true,
            "showEdit": false,
            "showView": true,
        }
        this.updateprivilege = this.updateprivilege.bind(this)
    }

    componentDidMount() {
        this.getlist();
        // this.date();
        let { id, slug } = this.props.match.params
        let { menuList } = this.props;

        let formSchema = Object.assign({}, formDataSchema);
        formSchema['feilds'].map((feild, key) => {
            formSchema['feilds'][key]['value'] = null;
            formSchema['feilds'][key]['text'] = null;
            formSchema['feilds'][key]['valid'] = false;
            formSchema['feilds'][key]['errors'] = [];
            delete formSchema['feilds'][key]['text'];

        })
        this.setState({ 'formData': formSchema['feilds'] });

        menuList.map((menu) => {
            if (slug !== undefined && slug !== null && slug !== '') {
                if (menu['route'] === id) {
                    menu['submenu'].map((smenu) => {
                        if (smenu['route'] === slug) {
                            this.setState((state) => ({
                                "showAdd": JSON.parse(smenu['permissions']['add']),
                                "showEdit": JSON.parse(smenu['permissions']['edit'])
                            }));
                        }
                    })
                }
            }
        })

        this.setState((state) => ({ 'loadding': true }), () => {
        })
    }

    componentDidUpdate(prevProps, prevState) {
        try {
            let { id, slug } = this.props.match.params;
            let { menuList } = this.props;
            let prevSlug = prevProps.match.params.slug;
            if (slug !== prevSlug) {
                menuList.map((menu) => {
                    if (slug !== undefined && slug !== null && slug !== '') {
                        if (menu['route'] === id) {
                            menu['submenu'].map((smenu) => {
                                if (smenu['route'] === slug) {
                                    this.setState((state) => ({
                                        "showAdd": JSON.parse(smenu['permissions']['add']),
                                        "showEdit": JSON.parse(smenu['permissions']['edit'])
                                    }));
                                }
                            })
                        }
                    }
                })

                this.setState((state) => ({ 'loadding': true }), () => {
                })
            }
        } catch (error) {
            console.log(error);
        }
    }

    componentWillUnmount() {
        this.setState({
            visible: false,
            formData: []
        });
    }

    // API
    getlist = () => {
        try {
            const { getPrivilegesList } = networkList;
            this.setState((state) => ({ thead: this.state.tableHead, loadding: true }), () => {
                postService(getPrivilegesList, 'GET', null).then(res => {
                    // console.log('privileges_list:', res.data);
                    if (res.status) {
                        this.setState((state) => ({ tbody: res.data, message: res.message, loadding: false }));
                    }
                    else {
                        // to catch api errors like --> network,url,outof status 1,0
                        Modal.error({
                            title: 'Failure',
                            content: "Oops! something went wrong... Please try again."
                        });
                    }
                })
            });
        } catch (error) {
            console.log(error);
            Modal.error({
                title: 'Failure',
                content: "Oops, something went wrong... Please try again.",
            });
        }
    }

    addprivilege() {
        const user = JSON.parse(Storage.get('user'));
        var formFeilds = this.state.formData;
        let errors = this.validateModalFeilds(formFeilds)
        let { date } = this.state
        if (!errors.includes(false)) {
            try {
                const { createPrivilegesList } = networkList;
                let data = {
                    'privilege_name': '',
                    'created_by': user,
                    'is_emergency': null,
                    'form_type_id': '',
                    'time_duration':0,
                    'only_admission':null,
                    'send_whatsapp_sms':null,
                }
                formFeilds.map((sva, key) => {
                    if (sva['name'] === 'privilege_name') {
                        data['privilege_name'] = sva['value'];
                    }
                    if (sva['name'] === 'emergency') {
                        data['is_emergency'] = parseInt(sva['value']);
                    }
                    if (sva['name'] === 'form_type') {
                        data['form_type_id'] = parseInt(sva['value']);
                    }
                    if(sva['name']==='time_duration'){
                        data['time_duration'] = parseInt(sva['value']);
                    }
                    if (sva['name'] === 'admission') {
                        data['only_admission'] = parseInt(sva['value']);
                    }
                    if (sva['name'] === 'whatsapp') {
                        data['send_whatsapp_sms'] = parseInt(sva['value']);
                    }
                });
                const Userlogobj ={
                    "data": {
                        "user": JSON.parse(localStorage.getItem('user')),
                        "action": "Create Privileges - Request",
                        "date": new Date(),
                        "meta":data
                    }
                }
                userTrackService(Userlogobj);
                this.setState((state) => ({ thead: this.state.tableHead, btnloading: true }), () => {
                    postService(createPrivilegesList, 'POST', data).then(res => {
                        const Userlogobjres ={
                            "data": {
                                "user": JSON.parse(localStorage.getItem('user')),
                                "action": "Create Privileges - Response",
                                "date": new Date(),
                                "meta":res
                            }
                        }
                        userTrackService(Userlogobjres);
                        if (res.status) {
                            // alert('Data inserted');
                            console.log('res', res)
                            this.getlist();
                            this.setState((state) => ({ btnloading: false }));
                            Modal.success({
                                title: 'success',
                                content: `${res.message}`,
                            });

                            let formSchema = Object.assign({}, formDataSchema);
                formSchema['feilds'].map((feild, key) => {
                    if(feild.name=='privilege_name'||  feild.name=='time_duration'){
                        formSchema['feilds'][key]['value'] = null;
                        formSchema['feilds'][key]['text'] = null;
                        formSchema['feilds'][key]['valid'] = false;
                        formSchema['feilds'][key]['errors'] = [];
                        formSchema['feilds'][key]['visible'] = false;
                        delete formSchema['feilds'][key]['text']; 
                        let This=this;
                        setTimeout(function () {
                            formSchema['feilds'][key]['visible'] = true;
                            This.setState((state) =>({'formData': formSchema['feilds']}))
                            },500)
                    }else{
                        formSchema['feilds'][key]['value'] = null;
                        formSchema['feilds'][key]['text'] = null;
                        formSchema['feilds'][key]['valid'] = false;
                        formSchema['feilds'][key]['errors'] = [];
                        delete formSchema['feilds'][key]['text'];
                    }
                    
                })
                this.setState({ 'formData': formSchema['feilds'] }); 
               
                            // notification.success({
                            //     message: 'Success',
                            //     description: `${res.message}`,
                            //     duration: 10,
                            //     top: 20,
                            //     right: 0
                            // });
                        } else {
                            // to catch api errors like --> network,url,outof status 1,0                       
                            this.setState((state) => ({ btnloading: false }));
                            Modal.error({
                                title: 'Failure',
                                content: `${res.message}`
                            });
                        }
                    })
                });
            } catch (error) {
                console.log(error);
                Modal.error({
                    title: 'Failure',
                    content: "Oops, something went wrong... Please try again.",
                });
            }
        }
    }

    updateprivilege() {
        const { editPrivilegesbyid } = networkList;
        const user = JSON.parse(Storage.get('user'));

        // console.log(this.state)

        var formFeilds = this.state.formData;
        let errors = this.validateModalFeilds(formFeilds)
        let data = {
            'id': this.state.privilege_id,
            'is_emergency': formFeilds[1].value,
            'form_type_id': formFeilds[2].value,
            'only_admission': formFeilds[3].value,
            'send_whatsapp_sms': formFeilds[4].value
        }
        console.log('updateprivilege', data)
        var name = formFeilds[0].value
        var emergency = parseInt(formFeilds[1].value)
        var form_type_id = formFeilds[2].value;
        var admission = parseInt(formFeilds[3].value)
        var whatsapp = parseInt(formFeilds[4].value) 
        if (!errors.includes(false)) {
            // console.clear();
            // console.log('addprivilege data:', data)
            this.setState((state) => ({ thead: this.state.tableHead, btnloading: true }), () => {
                postService(editPrivilegesbyid, 'PUT', {
                    'id': this.state.privilege_id,
                    'is_emergency': emergency,
                    'form_type_id': form_type_id,
                    'only_admission': admission,
                    'send_whatsapp_sms': whatsapp,
                }).then(res => {
                    if (res.status) {
                        // alert('Data inserted');
                        // console.log('res', res)
                        this.setState((state) => ({ btnloading: false, visible: false }));
                        this.getlist();
                        Modal.success({
                            title: 'Success',
                            content: `${res.message}`,
                        });
                        // notification.success({
                        //     message: 'Success',
                        //     description: `${res.message}`,
                        //     duration: 10,
                        //     top: 20,
                        //     right: 0
                        // });
                    } else {
                        // alert('Data not inserted');
                        Modal.error({
                            title: 'Failure',
                            content: `${res.message}`,
                        });
                    }
                })
            });
            this.getlist();
            let formSchema = Object.assign({}, formDataSchema);
            formSchema['feilds'].map((feild, key) => {
                formSchema['feilds'][key]['value'] = null;
                formSchema['feilds'][key]['text'] = null;
                formSchema['feilds'][key]['disable'] = false;
                formSchema['feilds'][key]['value'] = null;
                formSchema['feilds'][key]['valid'] = false;
                formSchema['feilds'][key]['errors'] = [];
                delete formSchema['feilds'][key]['text'];
            })

            this.setState({ 'formData': formSchema['feilds'] });
        }
    }
    // API ending
    date = () => {
        var monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
            'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
        var that = this;
        var date = new Date().getDate(); //Current Date
        var month = monthNames[new Date().getMonth()]; //Current Month
        var year = new Date().getFullYear(); //Current Year

        that.setState({
            //Setting the value of the date time
            date:
                date + ' ' + month + ' ' + year,
        });
    }

    showModal = (name, id) => {
        var pri = parseInt(id)

        // console.log('privilege_id:', this.state.privilege_id)
        // console.log('pri:', pri)
        this.setState((state) => ({ visible: true, privilege_name: name, privilege_id: pri }), () => {
            this.getPrivilegesbyid();
        })
    }

    handleChange(ele) {
        // console.log(ele);
        if (ele) {
            this
                .state
                .formData
                .map((data, key) => {

                });
        }
    }

    validateModalFeilds(formFeilds) {
        let errors = [];
        let role_id = null;
        formFeilds.map((feild, key) => {
            if (feild['element'] === 'input' || feild['element'] === 'select2' || feild['element'] === 'date') {
                if (feild['name'] === 'role_id' && feild['value'] === 'RL_fm8f') {
                    role_id = true;
                } else {
                    role_id = false;
                }
                formFeilds[key]['errors'] = [];
                if (!feild.disable) {
                    feild
                        .rules
                        .map((rule, rkey) => {
                            if (rule.test !== undefined && typeof rule.test === 'function' && !rule.test(feild['value'])) {
                                formFeilds[key]['errors'].push({ 'message': rule.message });
                                errors.push(false);
                            }
                        })
                }
            }
            if (role_id !== null && role_id) {

            }
        })

        this.setState((state) => ({ formData: formFeilds }));
        return errors;
    }

    handleCancel = e => {
        // console.log(e)
        let formSchema = Object.assign({}, formDataSchema);
        formSchema['feilds'].map((feild, key) => {
            formSchema['feilds'][key]['value'] = null;
            formSchema['feilds'][key]['valid'] = false;
            formSchema['feilds'][key]['errors'] = [];
            formSchema['feilds'][key]['disable'] = false;
            delete formSchema['feilds'][key]['text'];
        })
        this.setState({ visible: false, 'formData': formSchema['feilds'] });
    }

    onChange(checked,data) {
        try {
        const { disableprivilegebyid } = networkList;
        let obj = {};
        obj = { "id": data['pm_id'], "status": 0,'updated_at': this.state.date }
                    if (checked) {
                        obj['status'] = 1;
                    }
                    let That=this
                    confirm({
                        title: "Are you sure you want to delete this Privilege",
                        content: "",
                        onOk() {
                    const Userlogobj ={
                        "data": {
                            "user": JSON.parse(localStorage.getItem('user')),
                            "action": "Change status for Privilege - Request",
                            "date": new Date(),
                            "meta": obj
                        }
                    }
                    userTrackService(Userlogobj);
                    postService(disableprivilegebyid, 'POST', {'data': obj }).then(res => {
                        const Userlogobjres ={
                            "data": {
                                "user": JSON.parse(localStorage.getItem('user')),
                                "action": "Change status for Privilege - Response",
                                "date": new Date(),
                                "meta": res
                            }
                        }
                        userTrackService(Userlogobjres);
                        console.log(res);
                        if (res.status) {
                            // alert('Data inserted');
                            That.setState((state) => ({ tbody:[],'loadding': true}));
                            That.getlist();
                            Modal.success({
                                title: 'success',
                                content: "Your changes has been updated.",
                            });                    
                        } else {
                            // alert('Data not inserted');
                            Modal.error({
                                title: 'Failure',
                                content: "Oops, something went wrong... Please try again.",
                            });
                        }
                    });

                },
                onCancel() {
                    That.setState((state) => ({ tbody:[],'loadding': true}));
                    That.getlist();
                },
            });
        }catch (error) {
            console.log(error);
            this.setState((state) => ({ 'loadding': false }))
            Modal.error({
                title: 'Error message',
                content: 'Something went wrong. Please,try again later',
                onOk: function () {
                    window.scrollTo(0, 0);
                }
            });
        }
        // console.log(`switch to ${checked}`);
    }
    
    editclick(data) {
        const Userlogobj ={
            "data": {
                "user": JSON.parse(localStorage.getItem('user')),
                "action": "Edit Privileges",
                "date": new Date(),
                "meta":{
                    'id':data
                }
            }
        }
        userTrackService(Userlogobj);
        try {
            let { slug } = this.props.match.params;
            if (slug === 'privileges') {
                Storage.store('pre_link', this.props.location.search);
                this
                    .props
                    .history
                    .push('/settings/edit-privilege?rid=' + data);
            }
        } catch (error) {
            console.log(error)
        }
    }

    render() {
        let { thead, tbody, formData, showAdd, showEdit } = this.state;
        const user = JSON.parse(Storage.get('user'));
        // console.log(formData);
        return (
            <div>
                <div className="card m-5 card-table">
                    <div className="p-5">
                        <h1 className="text-heading text-center">Privilege List</h1>
                        {(showAdd) &&
                            <div className="row pt-4 justify-content-center">
                                {(formData !== undefined) && <React.Fragment>

                                    {formData
                                        .map((feild, key) => {

                                            if (feild.element === 'input' && feild.visible) {
                                                return (
                                                    <div
                                                        className={`${feild.className
                                                            ? feild.className
                                                            : 'col'} my-2 ${feild.name}`}
                                                        key={key}>
                                                        <div className="clearfix">
                                                            <p className="data-label w-100 mb-1">{feild.title}</p>
                                                        </div>
                                                        <Inputlayer
                                                            {...this.props}
                                                            {...this.state}
                                                            feildData={feild}
                                                            onInputChanges={this
                                                                .handleChange
                                                                .bind(this)}
                                                        />
                                                        {feild
                                                            .errors
                                                            .map((error, eKey) => {
                                                                return (
                                                                    <small key={eKey} className="form-text text-danger">{error.message}</small>
                                                                );
                                                            })}
                                                    </div>
                                                )
                                            }
                                            if (feild.element === 'select2' && feild.visible) {
                                                return (
                                                    <React.Fragment key={key}>
                                                        <div
                                                            className={`${feild.className
                                                                ? feild.className
                                                                : 'col '} my-2 ${feild.name}`}
                                                            key={key}>
                                                            <p className="data-label w-100 mb-1 ">{feild.title}</p>
                                                            <Select2
                                                                selectdata={feild}
                                                                // changedObj={this.state.changedObj}
                                                                {...this.props}
                                                                {...this.state}
                                                                // Queuedata={this.state.formData}
                                                                onselectChanges={this
                                                                    .handleChange
                                                                    .bind(this)}
                                                            />
                                                            {feild
                                                                .errors
                                                                .map((error, eKey) => {
                                                                    return (
                                                                        <small key={eKey} className="form-text text-danger">{error.message}</small>
                                                                    );
                                                                })}
                                                        </div>
                                                    </React.Fragment>
                                                )
                                            }
                                        })
                                    }
                                </React.Fragment>}
                                <div className="col-2" style={{paddingLeft: '25px'}}>
                                    <p className="data-label w-100 pt-3"></p>
                                    <Button className="btn btn-success text-capitalize mt-1" onClick={this.addprivilege.bind(this)} loading={this.state.btnloading}>Add privilege</Button>
                                </div>
                            </div>
                        }
                    </div>
                    <Spin spinning={this.state.loadding}>
                        <div className="financial-table table-responsive">
                            <table className="table table-hover table-bordered mb-0">
                                <thead>
                                    <tr>
                                        <td>S.No</td>
                                        <td>Service Name</td>
                                        {/* <td>Created By</td> */}
                                        <td>Creation Date</td>
                                        <td>Emergency</td>
                                        <td>Form Type</td>
                                        <td>Time Duration</td>
                                        <td>Admission</td>
                                        <td>Send Whatsapp</td>
                                        <td>Status</td>
                                        <td>Action</td>
                                        
                                    </tr>
                                </thead>

                                {this.state.message ?
                                    <tbody>
                                        <tr>
                                            <td colSpan="7" className="text-center">
                                                <img src={homepage+"/assets/images/icons/no-data.svg"} alt="" />
                                                <p className="no-data mb-0">No Data</p>
                                            </td>
                                        </tr>
                                    </tbody>
                                    :
                                    <tbody> {tbody.map((item, index) => {
                                        return (
                                            <tr key={index}>
                                            <td>{index + 1}</td>
                                            <td className="text-capitalize">{(item.privilege_name !== null) ? (item.privilege_name !== "null") ? item.privilege_name : "--" : "--"}</td>
                                            {/* <td className="text-capitalize">{(item.created_by !== null) ? (item.created_by !== "null") ? item.created_by : "--" : "--"}</td> */}
                                            <td>{item.created_at ? moment(item.created_at).format('DD MMM YYYY') : '--'}</td>
                                            <td> {item.is_emergency ? 'yes' : 'No'} </td>
                                            <td> {item.form_type_name ? item.form_type_name : ' '} </td>
                                            <td> {item.time_duration ? item.time_duration : '--'} </td>
                                            <td>{item.only_admission === "0" ? 'No' : item.only_admission === "1" ? 'Yes' : '--'}</td>
                                            <td>{item.send_whatsapp_sms === "0" ? 'No' : item.send_whatsapp_sms === "1" ? 'Yes' : '--'}</td>
                                            <td>
                                                <React.Fragment>
                                                    {showEdit 
                                                        ? (item.status !== undefined && item.status !== null && (item.status === 1 || item.status === "1")) 
                                                            ? <Switch defaultChecked onChange={(status) => this.onChange(status, item)} />
                                                            : (item.status !== undefined && item.status === null || (item.status === 0 || item.status === "0")) &&
                                                                <Switch onChange={(status) => this.onChange(status, item)} />
                                                        : item.status !== undefined && item.status !== null && (item.status === 1 || item.status === "1") 
                                                            ? "Active"
                                                            : item.status !== undefined && (item.status === null || (item.status === 0 || item.status === "0")) && "In-Active"
                                                    }
                                                </React.Fragment>
                                            </td>
                                            <td>
                                                {/* {user && user==="superadmin" ? */}
                                                {showEdit &&
                                                <Tooltip title="Edit">
                                                    <img src={homepage+"/assets/images/icons/edit.png"} alt="edit" className="mr-2" onClick={this.editclick.bind(this, item.id)} />
                                                </Tooltip> 
                                                }
                                                {/* {(showEdit === false && '---')} */}
                                            </td>                    
                                            
                                            </tr>
                                        )
                                    }
                                    )}
                                    </tbody>
                                }

                            </table>
                        </div>
                    </Spin>
                </div>
            </div>
        )
    }
}

export default Privilege_Create;